import React, { Fragment } from 'react';
import agentPageStore from '../store';
import { observer } from 'mobx-react-lite';
import globalStore from '@/store/global';
import Other from '@/common/helper/other';
import { SVGPureIcon } from '@/ui';
import { useLocation } from 'react-router-dom';
import client from '@/store/client';
import { Tooltip } from 'antd';
import { useEffect } from 'react';

const menuList = [
  {
    text: '我的智能体',
    icon: 'aiagent_mine',
    type: '',
    path: '/tools/aiagent/mine',
  },
  {
    text: '智能体广场',
    icon: 'aiagent_ai',
    type: 'agent',
    path: '/tools/aiagent',
  },
  {
    text: 'MCP 工具箱',
    icon: 'aiagent_skill',
    type: '',
    path: '/tools/aiagent/mcpsquare',
  },
  {
    text: '案例广场',
    icon: 'aiagent_case',
    type: '',
    path: '/tools/aiagent/case',
  },
];

const LeftMenu = observer(({ className = '' }) => {
  const location = useLocation();
  useEffect(() => {
    agentPageStore.updateChatLimit();
  }, []);

  return (
    <div className="flex-shrink-0 w-260px h-full overflow-auto nw-no-scroll py-20px pb-12px pl-13px pr-14px border-r-1px border-[rgba(0,0,0,0.06)] select-none flex flex-col">
      {menuList.map((item, index) => {
        const isCurRoute = item.path == location.pathname;
        const isAgent = item.type == 'agent';
        return (
          <Fragment key={index}>
            <div
              onClick={evt => {
                // agentPageStore.doWhenHasInvited(() => {
                if (isCurRoute) return;
                if (!(client.isLLQ || client.isSeLLQ) && item.path === '/tools/aiagent/mcpsquare') {
                  Other.toast('去PC端体验完整功能', 'warning');
                  setTimeout(() => {
                    client.openPage('/download');
                  }, 2 * 1000);
                  return;
                }
                if (item.path) {
                  globalStore.navigate(item.path);
                }
                if (item.onClick) {
                  item.onClick();
                }
                // })
              }}
              className={[
                'h-40px pl-10px pr-13px flex items-center rounded-12px cursor-pointer mb-4px !hover:bg-[rgba(0,0,0,0.03)]',
                isCurRoute && !isAgent ? 'bg-[rgba(0,0,0,0.06)]' : '',
              ]}
            >
              <SVGPureIcon name={item.icon} className="size-20px mr-8px" />
              <div className="text-14px text-black font-bold">{item.text}</div>
              {isAgent ? (
                <SVGPureIcon
                  onClick={agentPageStore.toggleFoldMenu}
                  name="aiagent_arrow"
                  className={[
                    'w-12px h-8px ml-auto',
                    'transform transition-all',
                    agentPageStore.foldMenu ? '' : 'rotate-180',
                  ]}
                />
              ) : null}
            </div>
            {isAgent && !agentPageStore.foldMenu ? (
              <>
                {agentPageStore.agentList.map((item, index) => {
                  const isCur =
                    agentPageStore.taIndex == index && isCurRoute && isAgent;
                  return (
                    <div
                      key={index}
                      onClick={evt => {
                        const isCurPage = location.pathname == '/tools/aiagent';
                        if (!isCurPage) {
                          globalStore.navigate('/tools/aiagent');
                          setTimeout(() => {
                            document
                              .querySelectorAll('.list-item-magic')
                              [index].scrollIntoView({
                                behavior: index == 0 ? 'smooth' : 'auto',
                                block: 'start',
                              });
                          }, 100);
                        } else {
                          document
                            .querySelectorAll('.list-item-magic')
                            [index].scrollIntoView({
                              behavior: 'smooth',
                              block: 'start',
                            });
                        }
                      }}
                      className={[
                        'h-40px flex items-center pl-38px mb-4px rounded-12px text-14px text-black cursor-pointer whitespace-nowrap !hover:bg-[rgba(0,0,0,0.03)]',
                        isCur
                          ? 'font-bold bg-[rgba(0,0,0,0.06)]'
                          : 'text-opacity-70 hover:text-opacity-100',
                      ]}
                    >
                      {item.title}
                    </div>
                  );
                })}
              </>
            ) : null}
          </Fragment>
        );
      })}
      <div className="h-0 flex-grow"></div>
      {
        agentPageStore.chatLimit?.daily_max
        ? (
          <div className="flex-shrink-0">
            <div className="bg-black bg-opacity-3 rounded-16px flex items-center justify-center h-72px">
              <div className="w-1/2 flex justify-center items-center text-14px leading-22px flex-col">
                <div className="h-22px">限免智能体</div>
                <div className="flex items-center h-22px">
                  剩余次数
                  <Tooltip
                    title={
                      <div className="whitespace-pre-wrap text-left">
                        {`规则：
    每月可免费使用 ${agentPageStore.chatLimit.daily_max || 0} 次
    您通过邀请好友额外获得了 ${agentPageStore.chatLimit.invite_total || 0} 次
    优先为您扣除时效性短的次数`}
                      </div>
                    }
                    >
                    <div className="size-16px ml-2px cursor-pointer">
                      <SVGPureIcon name="help" className='' />
                    </div>
                  </Tooltip>
                </div>
              </div>
              <div className="h-30px w-1px bg-black bg-opacity-6"></div>
              <div className="w-1/2 flex items-center justify-center font-bold">
                <div className="text-20px">{agentPageStore.chatLimit.daily_left + agentPageStore.chatLimit.invite_left}</div>
                <div className="text-14px relative ml-2px top-2px">次</div>
              </div>
            </div>
          </div>
        )
        : null
      }
    </div>
  );
});

export default LeftMenu;
